<template>
  <b-container class="d-flex justify-content-center align-items-center mt-3">
    <div style="text-align: left">
      <!-- スマホの場合 -->
      <div v-if="isMobile">データをロード中です</div>
      <!-- それ以外の場合 -->
      <div v-else>表示する組織を左上のドロップダウンから選択して下さい</div>
    </div>
  </b-container>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useAppStore } from "@/store";
import { NavigationGuardNext, Route } from "vue-router";

export default defineComponent({
  name: "domain-select",
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): void {
    // パラメータのリセット
    useAppStore().setTopicId("");
    useAppStore().setMessageId("");

    const to_domainId =
      to.params.domainId || (typeof to.query.domain_id == "string" ? to.query.domain_id : "");
    useAppStore().fetchData({ domainId: to_domainId, prevDomainId: from.params.domainId });
    next();
  },
  setup() {
    const isMobile = computed((): boolean => {
      return useAppStore().isMobile;
    });

    return {
      isMobile,
    };
  },
});
</script>
